<template>
	<v-container>
		<v-container pa-2>
			<div :class="['text-h6', 'd-flex', 'justify-center']">{{ $t('titles.candidate') }}</div>
		</v-container>
		<v-row wrap>
			<v-col cols="6">
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.first_name"
						:errorBorder="!candidateValidation.first_name"
						:label="'* ' + $t('fields.firstName')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.last_name"
						:errorBorder="!candidateValidation.last_name"
						:label="'* ' + $t('fields.lastName')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.oib"
						:errorBorder="!candidateValidation.oib"
						:label="'* ' + $t('fields.oib')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.id_card_or_passport_number"
						:errorBorder="!candidateValidation.id_card_or_passport_number"
						:label="$t('fields.idCardOrPassportNumber')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						:readonly="!inEditMode"
						v-model="candidate.date_of_birth"
						:errorBorder="!candidateValidation.date_of_birth"
						:date-label="'* ' + $t('fields.dateOfBirth')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.place_of_birth"
						:errorBorder="!candidateValidation.place_of_birth"
						:label="'* ' + $t('fields.placeOfBirth')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="candidate.country_of_birth_id"
						:ajax="true"
						:data="'countries'"
						:errorBorder="!candidateValidation.country_of_birth_id"
						:label="'* ' + $t('fields.countryOfBirth')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.address"
						:errorBorder="!candidateValidation.address"
						:label="$t('fields.address')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.postal_code"
						:errorBorder="!candidateValidation.postal_code"
						:label="$t('fields.postalCode')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.city"
						:errorBorder="!candidateValidation.city"
						:label="'* ' + $t('fields.city')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="candidate.county_id"
						:ajax="true"
						:clearable="true"
						:data="'counties'"
						:errorBorder="!candidateValidation.county_id"
						:label="$t('fields.county')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="candidate.country_id"
						:ajax="true"
						:data="'countries'"
						:errorBorder="!candidateValidation.country_id"
						:label="'* ' + $t('fields.country')"
					></Dropdown>
				</v-col>
			</v-col>
			<v-col cols="6">
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.phone"
						:errorBorder="!candidateValidation.phone"
						:label="'* ' + $t('fields.phone')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="candidate.email"
						:errorBorder="!candidateValidation.email"
						:label="'* ' + $t('fields.email')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="true"
						v-model="candidate.loyalty_points"
						:errorBorder="!candidateValidation.loyalty_points"
						:label="$t('fields.loyaltyPoints')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="candidate.partner_id"
						:ajax="true"
						:clearable="true"
						:data="'partners-buyers'"
						:errorBorder="!candidateValidation.partner_id"
						:label="$t('fields.company')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="candidate.rank_id"
						:ajax="true"
						:clearable="true"
						:data="'ranks'"
						:errorBorder="!candidateValidation.rank_id"
						:label="$t('fields.rank')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<Dropdown3
						:readonly="!inEditMode"
						v-model="loginTypeId"
						:ajax="true"
						:data="'preregistration-login-types'"
						:errorBorder="!loginTypeIdValidation"
						:label="'* ' + $t('fields.loginType')"
					></Dropdown3>
				</v-col>
				<v-col cols="12">
					<TextArea
						:readonly="!inEditMode"
						v-model="candidate.remark"
						:errorBorder="!candidateValidation.remark"
						:label="$t('fields.remark')"
						rows="3"
					></TextArea>
				</v-col>
				<v-col cols="12">
					<CheckBox
						:readonly="!inEditMode"
						v-model="candidate.loyalty_consent"
						:label="$t('fields.loyaltyConsent')"
					></CheckBox>
				</v-col>
				<v-col cols="12" v-if="candidate.loyalty_consent == true">
					<Upload
						:readonly="!inEditMode"
						:label="$t('fields.loyaltyConsent')"
						v-model="candidate.loyalty_file"
						:errorBorder="!candidateValidation.loyalty_file"
					></Upload>
				</v-col>
				<v-col cols="12">
					<CheckBox
						:readonly="!inEditMode"
						v-model="candidate.gdpr_consent"
						:label="$t('fields.gdprConsent')"
					></CheckBox>
				</v-col>
				<v-col cols="12" v-if="candidate.gdpr_consent == true">
					<Upload
						:readonly="!inEditMode"
						:label="$t('fields.gdprConsent')"
						v-model="candidate.gdpr_file"
						:errorBorder="!candidateValidation.gdpr_file"
					></Upload>
				</v-col>
				<v-col cols="12">
					<CheckBox
						:readonly="!inEditMode"
						v-model="candidate.active"
						:label="$t('fields.active')"
					></CheckBox>
				</v-col>
				<v-col cols="12">
					<CheckBox
						:readonly="!inEditMode"
						v-model="candidate.notifications"
						:label="$t('fields.notifications')"
					></CheckBox>
				</v-col>
			</v-col>
		</v-row>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12" class="d-flex justify-center">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Candidate from '../../../models/Candidate';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown3 from '../../trinkets/Dropdown3';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import Upload from '../../trinkets/Upload';

export default {
	name: 'NewCandidate',
	components: { CheckBox, InputField, DatePicker, Dropdown, Dropdown3, TextArea, Upload },
	props: {
		newCandidate: Object,
		inEditMode: Boolean,
		registration: {
			default: false,
			type: Boolean,
		},
	},
	emits: ['close', 'reloadCandidatesPreregistrations'],
	data: function () {
		return {
			candidate: new Candidate(this.newCandidate),
			candidateValidation: new Candidate({}, true),
			loginTypeId: this.newCandidate && this.newCandidate.login_type_id ? this.newCandidate.login_type_id : null,
			loginTypeIdValidation: true,
		};
	},
	watch: {
		newCandidate(newVal) {
			if (newVal) {
				this.candidate = new Candidate(this.newCandidate);
				this.loginTypeId = this.newCandidate.login_type_id ? this.newCandidate.login_type_id : null;
			}
		},
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.candidate.first_name == '') {
				success = false;
				this.candidateValidation.first_name = false;
			} else {
				if (this.candidate.first_name.length > 50) {
					this.candidateValidation.first_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.first_name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.first_name = true;
				}
			}

			if (this.candidate.last_name == '') {
				success = false;
				this.candidateValidation.last_name = false;
			} else {
				if (this.candidate.last_name.length > 50) {
					this.candidateValidation.last_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.last_name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.last_name = true;
				}
			}

			if (this.candidate.oib == null || this.candidate.oib == '') {
				success = false;
				this.candidateValidation.oib = false;
			} else {
				if (this.candidate.oib.length > 20) {
					this.candidateValidation.oib = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.oib'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.oib = true;
				}
			}

			if (this.candidate.id_card_or_passport_number != null && this.candidate.id_card_or_passport_number !== '') {
				if (
					this.candidate.id_card_or_passport_number != '' &&
					this.candidate.id_card_or_passport_number.length > 15
				) {
					this.candidateValidation.id_card_or_passport_number = false;
					success = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.idCardOrPassportNumber'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.id_card_or_passport_number = true;
				}
			}

			if (!this.candidate.date_of_birth) {
				success = false;
				this.candidateValidation.date_of_birth = false;
			} else {
				this.candidateValidation.date_of_birth = true;
			}

			if (this.candidate.place_of_birth == '') {
				success = false;
				this.candidateValidation.place_of_birth = false;
			} else {
				if (this.candidate.place_of_birth.length > 50) {
					this.candidateValidation.place_of_birth = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.place_of_birth'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.place_of_birth = true;
				}
			}

			if (!this.candidate.country_of_birth_id) {
				success = false;
				this.candidateValidation.country_of_birth_id = false;
			} else {
				this.candidateValidation.country_of_birth_id = true;
			}

			if (this.candidate.address.length > 50) {
				this.candidateValidation.address = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.address'))
						.replace('%length%', '50') + '<br />';
			} else {
				this.candidateValidation.address = true;
			}

			if (this.candidate.postal_code != null && this.candidate.postal_code.length > 20) {
				this.candidateValidation.postal_code = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.postal_code'))
						.replace('%length%', '20') + '<br />';
			} else {
				this.candidateValidation.postal_code = true;
			}

			if (this.candidate.city == '') {
				success = false;
				this.candidateValidation.city = false;
			} else {
				if (this.candidate.city.length > 50) {
					this.candidateValidation.city = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.city'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.city = true;
				}
			}

			if (!this.candidate.country_id) {
				success = false;
				this.candidateValidation.country_id = false;
			} else {
				this.candidateValidation.country_id = true;
			}

			if (this.candidate.phone == '') {
				success = false;
				this.candidateValidation.phone = false;
			} else {
				if (this.candidate.phone.length > 20) {
					this.candidateValidation.phone = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.phone'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.phone = true;
				}
			}

			if (this.candidate.email == '') {
				success = false;
				this.candidateValidation.email = false;
			} else {
				if (!this.$checkEmail(this.candidate.email)) {
					this.candidateValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.candidateValidation.email = true;
				}
			}

			if (this.candidate.remark != null && this.candidate.remark.length > 500) {
				this.candidateValidation.remark = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.remark'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.candidateValidation.remark = true;
			}

			if (!this.loginTypeId) {
				success = false;
				this.loginTypeIdValidation = false;
			} else {
				this.loginTypeIdValidation = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				this.candidate.login_type_id = this.loginTypeId;
				if (this.registration) {
					this.candidate.registration = true;
					this.candidate.planned_course_id = this.$route.params.id;
				}
				this.$APICall(action, 'candidates' + addition, this.candidate, (data, success) => {
					if (success) {
						if (data == 409) {
							vm.$alert(vm.$t('alerts.oibExists'));
							vm.candidateValidation.oib = false;
							return;
						}
						if (data == 422) {
							vm.$alert(vm.$t('alerts.candidateCreatedButIsNotEnrolled'));
							vm.$emit('close');
							this.$router.go(-1);
							return;
						}
						vm.$notify(vm.$t('alerts.basicAdd'));
						if (vm.registration) {
							vm.$modalBus.$emit('reloadCandidatesRegistrations');
							vm.$modalBus.$emit('reloadPlannedCourse');
						} else {
							vm.$modalBus.$emit('reloadCandidatesPreregistrations');
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					vm.$emit('close');
				});
			}
		},
	},
};
</script>
